import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from './CTAButton';
import { trackInitiateCheckout } from './MetaPixel';
export function FloatingCTA({
  triggerId
}: {
  triggerId: string;
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const target = document.getElementById(triggerId);
    if (!target) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show once the first CTA has scrolled past the top of the viewport
      setVisible(entry.boundingClientRect.top < 0);
    }, {
      threshold: 0,
      rootMargin: '0px'
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, [triggerId]);
  return <AnimatePresence data-id="element-99" data-mp="38bh1o3b2u01q">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-navy-100 bg-white/95 px-3 pb-[max(10px,env(safe-area-inset-bottom))] pt-2.5 backdrop-blur-md shadow-[0_-6px_24px_rgba(16,36,68,0.12)]" data-id="element-100" data-mp="38cjtqek4y8j8">
          <div className="mx-auto flex max-w-md flex-col items-center" data-id="element-101" data-mp="2pabk78wv58iz">
            <a href={CHECKOUT_URL} onClick={() => trackInitiateCheckout()} className="flex w-full items-center justify-center gap-2 rounded-xl bg-brandblue px-4 py-3.5 text-center text-[14px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-md transition-colors hover:bg-brandblue-dark active:scale-[0.98] sm:text-base" data-id="element-102" data-mp="2u9ego4ys26fc">
              Quiero el Kit Clínico ahora
              <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-103" data-mp="4m6s3zc8g1dl" />
            </a>
            <p className="mt-1.5 text-[11px] font-medium text-navy/55" data-id="element-104" data-mp="9l09i2un4cj1">
              $15 USD · Pago único · Acceso de por vida
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}